<ion-app class="global-width">
  <ion-split-pane [when]="isLoggedIn && showSplitPane && (scrWidth>=992) && (canSideMenuDisplayed())"
                  contentId="menu-content">
    <ion-menu [hidden]="!isLoggedIn"
              class="do-not-print"
              contentId="menu-content"
              id="main-menu">
      <ion-content>
        <uab-menu-list (onComplete)="completeFeatures()"></uab-menu-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="menu-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>

<uab-complete-profile-modal *ngIf="isLoggedIn"></uab-complete-profile-modal>
<uab-splash-screen></uab-splash-screen>
<uab-logging-out-modal></uab-logging-out-modal>
<uab-browser-block></uab-browser-block>
